import { useTolgee } from '@tolgee/react';

import { DEFAULT_LANGUAGE } from '../constants/i18n';

export function useTolgeeLocale() {
  const { getLanguage } = useTolgee();

  return getLanguage() || DEFAULT_LANGUAGE;
}
